<template>
    <div
        class="rounded"
        :class="{ 'bg-danger text-white': !event.ttsessiontype && !event.rgb }"
        :style="{
            backgroundColor: markAbsent ? '#E45252' : getEventBgColor(event),
            color: markAbsent ? 'white' : getEventTextColor(event),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }"
        @click="$emit('click')"
    >
        <div
            :class="slim ? 'd-none' : hideDetailsOnSmallScreen ? 'd-inline d-md-none' : 'd-none'"
            :style="{ whiteSpace: 'nowrap' }"
        >
            <span v-if="event.from">{{ from }}</span>
            <span v-if="event.ttroom"><br>{{ event.ttroom.name }}</span>
            <span v-else-if="event.title">{{ event.title }}</span>
            <span v-if="markAbsent"><br>{{ $t('{s}-absent', {s: ''}) }}</span>
        </div>

        <div :class="{ 'd-none d-md-inline': hideDetailsOnSmallScreen, 'd-inline': slim }">
            <template v-if="!slim">
                <template v-if="event.from && event.to">
                    {{ `${from} - ${to}` }}
                </template>
                <span v-else-if="event.day" class="bg-event-text">
                    {{  (event.title ? `${event.title} - ` : '') + `${$t('day')} ${event.day}` }}
                </span>
            </template>
            <br v-if="!slim" />
            <span v-if="event.ttsessiontype && event.ttsessiontype.name">
                {{ event.ttsessiontype.name }}<span v-if="event.ttroom"> - {{ event.ttroom.name }}</span>
            </span>
            <span v-if="showTeacherDetails">
                {{ $t('attending-colon') }} {{ onRota + added - absent }}
                {{ $t('absent-colon') }}  {{ absent }}
            </span>
            <span v-if="markAbsent && !slim">{{ $t('{s}-absent', {s: ''}) }}</span>
        </div>
    </div>
</template>

<script>
import { rgbToHex, getTextColor } from 'src/modules/timetable/util'

export default {
    props: {
        event: {
            type: Object,
            required: true,
        },
        slim: {
            type: Boolean,
            default: false,
        },
        hideDetailsOnSmallScreen: {
            type: Boolean,
            default: false,
        },
        showTeacherDetails: {
            type: Boolean,
            default: false,
        },
        markAbsent: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        if (this.event.teachers && this.showTeacherDetails) this.event.teachers.forEach(teacher => {
            if (teacher.on_rota) this.onRota++
            else this.added++

            if (teacher.substitute_id) this.subs++
            else if (teacher.absent) this.absent++
        })
    },
    data() {
        return {
            onRota: 0,
            absent: 0,
            subs: 0,
            added: 0,
        }
    },
    methods: {
        getEventBgColor(event) {
            return event.rgb
            ? rgbToHex(event.rgb[0], event.rgb[1], event.rgb[2])
            : Number(event.cancelled)
            ? '#CCC'
            : event.ttsessiontype && event.ttsessiontype.colourcode
            ? `#${event.ttsessiontype.colourcode}`
            : undefined
        },
        getEventTextColor(event) {
            return event.rgb
            ? getTextColor(null, event.rgb)
            : event.ttsessiontype && event.ttsessiontype.colourcode
            ? getTextColor(event.ttsessiontype.colourcode)
            : Number(event.cancelled)
            ? 'black'
            : 'white'
        },
    },
    computed: {
        from() {
            return this.$datetime.timestampToTime(Number(this.event.from), false)
        },
        to() {
            return this.$datetime.timestampToTime(Number(this.event.to), false)
        },
        hideSmallClass() {
        	return this.hideDetailsOnSmallScreen ? 'd-none d-md-inline' : ''
        },
        showSmallClass() {
            return this.hideDetailsOnSmallScreen ? 'd-inline d-md-none' : ''
        }
    }
}
</script>

<style scoped lang="scss">
.bg-event-text {
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
